module.exports = __webpack_public_path__ + "472da29ca14361a75a3d1320c4378bf3.pdf";